import { render } from "./back.vue?vue&type=template&id=3b0fffa2"
import script from "./back.vue?vue&type=script&lang=js"
export * from "./back.vue?vue&type=script&lang=js"

import exportComponent from "C:\\inetpub\\wwwroot\\bidi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__